export default "__VITE_ASSET__C641R7PB__"